"use client";
import dynamic from 'next/dynamic';
const Modal = dynamic(() => import('reactstrap/lib/Modal').then((module) => ({ default: module.default })),{ ssr: true });
const ModalFooter = dynamic(() => import('reactstrap/lib/ModalFooter').then((module) => ({ default: module.default })),{ ssr: true });
const ModalHeader = dynamic(() => import('reactstrap/lib/ModalHeader').then((module) => ({ default: module.default })),{ ssr: true });
const ModalBody = dynamic(() => import('reactstrap/lib/ModalBody').then((module) => ({ default: module.default })),{ ssr: true });
export {ModalBody, ModalFooter, ModalHeader,Modal }